module.exports = __webpack_public_path__ + "static/brand-logo-49257c05475ca6e498c12e22d99182b7.png";